import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'formattadata'
})

export class FormattaDataPipe implements PipeTransform {
    /** in base al parametro passato si setta la data locale
     * @param  {any} value
     */
    transform(value: any ): string {
        let valore : string = "";
        if (value != null) {
            let data = new Date(value.replace(' ', 'T'));
            valore = data.toLocaleDateString(localStorage.getItem('locale') || 'it');
        }
        return valore;
    }
}